import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const externalDeliveryFileDetailService = (fileId) => {
  return axiosInstance
    .get(`${ENDPOINTS.ADMIN.EXTERNAL_DELIVERY.READ_FILE}/${fileId}`)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
